import { action } from 'satcheljs';
import { type LicensingMailboxInfo } from 'owa-account-source-list-types';

export interface ON_APP_LICENSING_INFOS_CHANGEDActionMessage {
    updatedLicensingMailboxes: LicensingMailboxInfo[];
    addedLicensingMailboxes: LicensingMailboxInfo[];
    removedLicensingMailboxes: LicensingMailboxInfo[];
    policyChanges: LicensingMailboxInfo[];
}

/**
 * This action is dispatched when the licensing mailboxes are changed in
 * the owa-account-source-list-store.
 */
const defaultExport: (
    updatedLicensingMailboxes: LicensingMailboxInfo[],
    addedLicensingMailboxes: LicensingMailboxInfo[],
    removedLicensingMailboxes: LicensingMailboxInfo[],
    policyChanges: LicensingMailboxInfo[]
) => ON_APP_LICENSING_INFOS_CHANGEDActionMessage = action(
    'ON_APP_LICENSING_INFOS_CHANGED',
    (
        // The updated licensing mailboxes, that is the array of the currently configured licensing mailboxes
        updatedLicensingMailboxes: LicensingMailboxInfo[],
        // Licensing mailboxes that were added as part of this change
        addedLicensingMailboxes: LicensingMailboxInfo[],
        // Licensing mailboxes that were removed as part of this change
        removedLicensingMailboxes: LicensingMailboxInfo[],
        // Licensing mailboxes that had their policy state changed
        policyChanges: LicensingMailboxInfo[]
    ): ON_APP_LICENSING_INFOS_CHANGEDActionMessage => ({
        updatedLicensingMailboxes,
        addedLicensingMailboxes,
        removedLicensingMailboxes,
        policyChanges,
    })
);
export default defaultExport;
